import httpUtils from '../../utils/HttpUtils'

class CompanyService {
  async getCompanyInfo (id = '') {
    var result = null;
    try {
      result = await httpUtils.post('/server/company/info',{id});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async getCompanyList () {
      var result = null;
      try {
          result = await httpUtils.post('/server/company/list');
      } catch (e) {
          console.log('连接失败', e);
          result = {code: 1, msg: '连接失败'}
      }
      return result
  }
}
export default new CompanyService()
